import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as d3 from 'd3';
import * as d3Chromatic from 'd3-scale-chromatic';
import { DataService } from '../../services/data.service';
import { TranslateService } from '@ngx-translate/core';
let zonedata = [];
@Component({
    selector: 'app-d3-zone-chart',
    templateUrl: './d3-zone-chart.component.html',
    styleUrls: ['./d3-zone-chart.component.scss'],
    standalone: false
})
export class D3ZoneChartComponent implements OnChanges {
  @Input() zoneType: any;
  @Input() zonedata: any;
  @Input() isOnDialog: boolean = false;
  @Input() chartId: string = 'zoneChart';
  subscription: any;
  constructor(private dataSer: DataService,
    private translate: TranslateService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.drawzonechart();
  }

  drawzonechart() {
    const divId = this.isOnDialog ? '#my_datavizsec' : '#my_dataviz2';
    let ppcp = '';
    let ppkcpk = '';
    // set the dimensions and margins of the graph
    const parentDiv = this.isOnDialog ? 'my_datavizsec' : 'left-col-dash';
    const div: any = document.getElementById(parentDiv);
    let width = div ? div.offsetWidth - 30 : 870;
    const margin = { top: 10, right: 30, bottom: 40, left: 50 };
    width = width - margin.left - margin.right;
    let height = (this.isOnDialog ? 450 : 350) - margin.top - margin.bottom;
    if (this.isOnDialog) {
      height = window.screen.height * 0.8 - 235 - margin.top - margin.bottom;
    }
    if (this.zoneType === 'P') {
      ppcp = 'Pp';
      ppkcpk = 'Ppk';
    } else {
      ppcp = 'Cp';
      ppkcpk = 'Cpk';
    }
    d3.selectAll('#' + this.chartId).remove();
    // append the svg object to the body of the page
    const Svg = d3.select(divId)
      .append('svg')
      .attr('id', this.chartId)
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    zonedata = this.zonedata;
    if (!zonedata) {
      return;
    }
    // Add X axis
    const extent = d3.extent(zonedata, d => d.cpkppk);
    const linewidth = 5;
    let negativeYaxis = Math.floor(extent[0]);  // 180
    negativeYaxis = isNaN(negativeYaxis) ? 0 : negativeYaxis;
    let CBzone = 0;

    if (negativeYaxis === 0) {
      CBzone = 295;
    } else if (negativeYaxis === -1) {
      CBzone = 290;
    } else if (negativeYaxis === -2) {
      CBzone = 250;
    } else if (negativeYaxis === -3) {
      CBzone = 220;
    } else if (negativeYaxis === -4) {
      CBzone = 200;
    } else if (negativeYaxis === -5) {
      CBzone = 180;
    }

    const x = d3.scaleLinear()
      .domain([0, linewidth])
      .range([0, width]);
    Svg.append('g')
      .attr('transform', 'translate(0,' + height + ')')
      .call(d3.axisBottom(x)
        .tickSize(-height * 1.3)
        .ticks(10)
        .tickPadding(11)
        // .tickFormat((d: any) => d === 0 ? '' : d)
      )
      .select('.domain').remove();

    // Add Y axis
    const y = d3.scaleLinear()
      .domain([negativeYaxis, linewidth]) // -1
      .range([height, 0])
      .nice();

    //  Svg.append("g")
    //   .call(d3.axisLeft(y))


    Svg.append('g')
      .call(d3.axisLeft(y).tickSize(-width * 1).ticks(7)
        .tickFormat((d: any, i: any) => i === 0 ? d + '  ' : d))
      .select('.domain').remove();

    // Customization
    Svg.selectAll('.tick line').attr('stroke', '#EBEBEB');
    Svg.selectAll('.tick text').attr('stroke', 'grey').style('font-size', 12);

    // Add X axis label:
    Svg.append('text')
      .attr('text-anchor', 'end')
      .attr('x', width - 40)
      .attr('y', height + margin.top + 26)
      .text(ppcp);

    // Y axis label:
    Svg.append('text')
      .attr('text-anchor', 'end')
      .attr('transform', 'rotate(-90)')
      .attr('y', -margin.left + 20)
      .attr('x', -margin.top)
      .text(ppkcpk);

    const tooltip = d3.select(divId)
      .append('div')
      .style('opacity', 0)
      .style('display', 'none')
      .attr('class', 'tooltip')
      .style('background-color', 'white')
      .style('border', 'solid')
      .style('border-width', '1px')
      .style('min-width', '150px')
      .style('z-index', '1000')
      .style('border-radius', '5px')
      .style('padding', '10px');


    // A function that change this tooltip when the user hover a point.
    // Its opacity is set to 1: we can now see it. Plus it set the text and position of tooltip depending on the datapoint (d)
    const mouseover = ((d) => {
      tooltip
        .style('opacity', 1)
        .style('display', 'block');
    });
    const infinityImg = '<img src="assets/images/infinity.svg"/>';
    const mousemove = function (d) {
      tooltip
        .html(d.cppp > 50 ? 'Parameter Name: ' + d.parameterName + '<br>' + infinityImg : 'Parameter Name: ' + d.parameterName + '<br>'
          + ppcp + ':' + d.cppp + ' ' + ppkcpk + ':' + d.cpkppk)
        .style('left', (d3.mouse(this)[0] + 90) + 'px')
        .style('top', (d3.mouse(this)[1] + 50) + 'px');
    };

    // A function that change this tooltip when the leaves a point: just need to set opacity to 0 again
    const mouseleave = ((d) => {
      tooltip
        .transition()
        .duration(200)
        .style('opacity', 0)
        .style('display', 'none');
    });

    // Color scale: give me a specie name, I return a color
    const color = d3.scaleOrdinal(d3.schemeCategory10)
      .domain(['A', 'B', 'C', 'D', 'E'])
      .range(['#0fbe52', 'darkblue', '#f44336', '#000000', '#000000']);
    // .range(['#03fc0f', 'blue', '#FF0000', '#000000', '#6b7d98']);

    /* Background Zone D Start */
    let xx1: any = x(0);
    let yy1: any = isNaN(y(0)) ? 0 : y(0);
    let xx2: any = x(linewidth);
    let yy2: any = isNaN(y(linewidth)) ? 0 : y(linewidth);
    let xx3: any = x(0);
    let yy3: any = isNaN(y(linewidth)) ? 0 : y(linewidth);
    let xx4: any = '0';
    let yy4: any = isNaN(y(linewidth)) ? 0 : y(linewidth);
    let points: any = `${xx1},${yy1} ${xx2},${yy2} ${xx3},${yy3}`;

    Svg.append("polygon")
      .attr("points", points)
      .style("fill", 'lightgray')
      .style("opacity", "0.5")
      .style("strokeWidth", "10px");

    /* Zone A Background */
    xx1 = x(1);
    yy1 = isNaN(y(1)) ? 0 : y(1);
    xx2 = x(linewidth);
    yy2 = isNaN(y(linewidth)) ? 0 : y(linewidth);
    xx3 = x(linewidth);
    yy3 = isNaN(y(1)) ? 0 : y(1);
    xx4 = x(1);
    yy4 = isNaN(y(1)) ? 0 : y(1);
    points = `${xx1},${yy1} ${xx2},${yy2} ${xx3},${yy3}`;

    Svg.append("polygon")
      .attr("points", points)
      .style("fill", 'palegreen')
      .style("opacity", "0.7")
      .style("strokeWidth", "10px");

    /* Zone B Background */
    xx1 = x(1);
    yy1 = isNaN(y(1)) ? 0 : y(1);
    xx2 = x(linewidth);
    yy2 = isNaN(y(1)) ? 0 : y(1);
    xx3 = x(linewidth);
    yy3 = isNaN(y(negativeYaxis)) ? 0 : y(negativeYaxis);
    xx4 = x(1);
    yy4 = isNaN(y(negativeYaxis)) ? 0 : y(negativeYaxis);
    points = `${xx1},${yy1} ${xx2},${yy2} ${xx3},${yy3} ${xx4},${yy4}`;

    Svg.append("polygon")
      .attr("points", points)
      .style("opacity", "0.7")
      .style("fill", 'lightskyblue')
      .style("strokeWidth", "10px");

    /* Zone C Background */
    xx1 = x(0);
    yy1 = isNaN(y(0)) ? 0 : y(0);
    xx2 = x(1);
    yy2 = isNaN(y(1)) ? 0 : y(1);
    xx3 = x(1);
    yy3 = isNaN(y(negativeYaxis)) ? 0 : y(negativeYaxis);
    xx4 = x(0);
    yy4 = isNaN(y(negativeYaxis)) ? 0 : y(negativeYaxis);
    const xx5 = x(0);
    const yy5 = isNaN(y(negativeYaxis)) ? 0 : y(negativeYaxis);
    points = `${xx1},${yy1} ${xx2},${yy2} ${xx3},${yy3} ${xx4},${yy4} ${xx5},${yy5}`;

    Svg.append("polygon")
      .attr("points", points)
      .style("fill", 'pink')
      .style("opacity", "0.7")
      .style("strokeWidth", "10px");

    /* Background End */

    // draw inclind line
    // Svg.append('line')
    //   .style('stroke', '#402D54')
    //   .attr('x1', x(0))
    //   .attr('y1', isNaN(y(0)) ? 0 : y(0))
    //   .attr('x2', x(linewidth))
    //   .attr('y2', isNaN(y(linewidth)) ? 0 : y(linewidth));

    // draw vertical line
    // Svg.append('line')
    //   .style('stroke', 'black')
    //   .attr('x1', x(1))
    //   .attr('y1', isNaN(y(0)) ? 0 : y(0))
    //   .attr('x2', x(1))
    //   .attr('y2', isNaN(y(1)) ? 0 : y(1));

    // draw Horizantal line
    // Svg.append('line')
    //   .style('stroke', 'black')
    //   .attr('x1', x(1))
    //   .attr('y1', isNaN(y(1)) ? 0 : y(1))
    //   .attr('x2', x(linewidth))
    //   .attr('y2', isNaN(y(1)) ? 0 : y(1));

    // draw Horizantal line yellow
    Svg.append('line')
      .attr('class', 'dashed')
      .style('stroke', 'yellow')
      .attr('x1', x(0))
      .attr('y1', isNaN(y(0)) ? 0 : y(0))
      .attr('x2', x(linewidth))
      .attr('y2', isNaN(y(0)) ? 0 : y(0));

    // draw X axis line - ve
    Svg.append('line')
      .style('stroke', 'black')
      .attr('x1', x(0))
      .attr('y1', y(negativeYaxis))
      .attr('x2', x(linewidth))
      .attr('y2', y(negativeYaxis));

    // draw Y axis line -ve
    Svg.append('line')
      .style('stroke', 'black')
      .attr('x1', x(0))
      .attr('y1', isNaN(y(linewidth)) ? 0 : y(linewidth))
      .attr('x2', x(0))
      .attr('y2', isNaN(y(negativeYaxis)) ? 0 : y(negativeYaxis));


    if (!zonedata || zonedata.length === 0) {
      Svg.append('text')
        .attr('text-anchor', 'end')
        .attr('transform', 'translate(' + width / 2 + ',' + 75 + ')')
        .text(this.translate.instant("common.no_data"))
        .style('fill', '#000000')
        .style('font-weight', 'bold')
        .style('font-size', '14');
      return;
    }
    /*
        Svg.append('text')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate(' + (width / 4) + ',' + 75 + ')')
          .text('Zone D')
          .style('fill', '#000000')
          .style('font-weight', 'bold')
          .style('font-size', '14');
    
        Svg.append('text')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate(' + (width - 10) + ',' + 75 + ')')
          .text('Zone A')
          .style('fill', 'green')
          .style('font-weight', 'bold')
          .style('font-size', '14');
    
        Svg.append('text')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate(' + (width - 10) + ',' + CBzone + ')') // 293
          .text('Zone B')
          .style('fill', 'blue')
          .style('font-weight', 'bold')
          .style('font-size', '14');
    
        Svg.append('text')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate(' + (width / 4 - 15) + ',' + CBzone + ')')  // 293  2-250 3-220 1-290 0-350
          .text('Zone C')
          .style('fill', '#FF0000')
          .style('font-weight', 'bold')
          .style('font-size', '14');*/

    // Add dots
    Svg.append('g')
      .selectAll('dot')
      .data(zonedata)
      .enter()
      .append('circle')
      .attr('cx', (d) => x(d.cppp))
      .attr('cy', (d) => y(d.cpkppk))
      .attr('r', 5)
      .style('fill', (d) => color(d.zone))
      .on('mouseover', mouseover)
      .on('mousemove', mousemove)
      .on('mouseleave', mouseleave);
  }


}
